"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var $ = require("jquery");
var ko = require("knockout");
var _ = require("lodash");
var tippy = require('tippy.js').default;
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var metrikaUtils_1 = require("../../app/utils/metrikaUtils");
var baseViewModel_1 = require("./base/baseViewModel");
var ViewModel = (function (_super) {
    __extends(ViewModel, _super);
    function ViewModel(options) {
        var _this = this;
        _super.call(this, options);
        this.animationTime = 1920 * 2;
        this.$workPopover = $("#workInLibraryPopover");
        this.$markPopover = $("#markPopover");
        this.stateWithoutHideWork = ["liked", "marks"];
        this.backHistoryAfterClose = true;
        this.marksLineBarIsTippy = false;
        this.defaultFilters = this.options.defaultFilters;
        this.readingCount = ko.observable();
        this.savedCount = ko.observable();
        this.finishedCount = ko.observable();
        this.marksCount = ko.observable();
        this.likedCount = ko.observable();
        this.purchasedCount = ko.observable();
        this.dislikedCount = ko.observable();
        this.allCount = ko.observable();
        this.filtersCount = ko.observable();
        this.selectedWorkId = ko.observable();
        this.isLoading = ko.observable(false);
        this.genre = ko.observableArray();
        this.state = ko.observable();
        this.workMarks = ko.observableArray();
        this.selectedWork = ko.observable();
        this.tabs = {
            reading: {
                title: "Читаю / слушаю",
                icon: "icon-2-library-reading"
            },
            saved: {
                title: "Отложено на потом",
                icon: "icon-2-clock"
            },
            finished: {
                title: "Прочитано",
                icon: "icon-2-library-finished"
            },
            disliked: {
                title: "Не нравится",
                icon: "icon-eye-slash"
            },
            none: {
                icon: "icon-ellipsis"
            }
        };
        this.toggleLike = function () {
            if (_this.isLoading())
                return;
            _this.isLoading(true);
            var work = _this.selectedWork();
            var $el = $("[data-work-id = " + work.id + "]");
            var isLiked = !work.isLiked;
            _this.closeWorkPopover();
            ajaxUtils_1.AjaxUtils.post("work/like", {
                targetId: work.id,
                isLiked: isLiked
            }).done(function (result) {
                if (!result.isSuccessful) {
                    alert(result.messages[0]);
                    return;
                }
                work.isLiked = isLiked;
                $el.attr("data-work", ko.toJSON(work));
                alert("\u0412\u044B \u0443\u0431\u0440\u0430\u043B\u0438 \u043E\u0442\u043C\u0435\u0442\u043A\u0443 \u00AB\u041D\u0440\u0430\u0432\u0438\u0442\u0441\u044F\u00BB");
                _this.likedCount(_this.likedCount() + (isLiked ? 1 : -1));
            }).always(function () {
                _this.isLoading(false);
            });
        };
        this.toggleMark = function (mark, viewModel, event) {
            if (_this.isLoading())
                return;
            _this.isLoading(true);
            var work = _this.selectedWork();
            var workId = work.id;
            var isActive = work.marks.indexOf(mark) === -1;
            var $img = $(event.target);
            $img.attr("src", $img.attr("data-animated-src"));
            setTimeout(function () {
                $img.attr("src", $img.attr("data-src"));
            }, _this.animationTime);
            ajaxUtils_1.AjaxUtils.post("work/mark", {
                workId: workId,
                isActive: isActive,
                mark: mark
            }).done(function (result) {
                if (!result.isSuccessful) {
                    alert(result.messages[0]);
                    return;
                }
                work.marks = result.data.marks;
                _this.workMarks(work.marks);
                $("[data-work-id = " + workId + "]").attr("data-work", ko.toJSON(work));
            }).always(function () {
                _this.isLoading(false);
            });
        };
        this.updateLibraryState = function (newState, title) {
            if (_this.isLoading())
                return;
            _this.isLoading(true);
            var work = _this.selectedWork();
            _this.closeWorkPopover();
            ajaxUtils_1.AjaxUtils.post("work/updateLibrary", {
                ids: [work.id],
                state: newState
            }).done(function (result) {
                if (!result.isSuccessful) {
                    app.f7.addNotification({ message: result.messages[0], button: { text: "ОК", close: true, color: "red" }, hold: 5000 });
                    return;
                }
                var $el = $("[data-work-id = " + work.id + "]");
                var oldState = work.state;
                work.state = newState;
                $el.attr("data-work", ko.toJSON(work));
                if (newState === "none") {
                    alert("\u0412\u044B \u0443\u0434\u0430\u043B\u0438\u043B\u0438 \u043A\u043D\u0438\u0433\u0443 \u0438\u0437 \u0431\u0438\u0431\u043B\u0438\u043E\u0442\u0435\u043A\u0438.");
                    _this.allCount(_this.allCount() - 1);
                    var oldStateObs = oldState.toLowerCase() + "Count";
                    _this[oldStateObs](_this[oldStateObs]() - 1);
                    return;
                }
                else if (oldState === "none") {
                    _this.allCount(_this.allCount() + 1);
                }
                if (oldState !== newState.toLowerCase()) {
                    var newStateObs = newState.toLowerCase() + "Count";
                    _this[newStateObs](_this[newStateObs]() + 1);
                    if (oldState !== "none") {
                        var oldStateObs = oldState.toLowerCase() + "Count";
                        _this[oldStateObs](_this[oldStateObs]() - 1);
                    }
                }
                alert("\u0412\u044B \u043F\u0435\u0440\u0435\u043C\u0435\u0441\u0442\u0438\u043B\u0438 \u043A\u043D\u0438\u0433\u0443 \u043D\u0430 \u043F\u043E\u043B\u043A\u0443 \"" + title + "\".");
            }).always(function () {
                _this.isLoading(false);
            });
        };
        this.goToReader = function () {
            var work = _this.selectedWork();
            if (work.format === 'EBook') {
                metrikaUtils_1.default.reachGoal("goToReader", { from: "Library" });
                _this.redirectToPage(app.rootUrl + "reader/" + work.id);
            }
            else if (work.format === 'Audiobook') {
                metrikaUtils_1.default.reachGoal("startAudio", { from: "Library" });
                _this.redirectToPage(app.rootUrl + "audiobook/" + work.id + "#startAudio");
            }
        };
        this.goToMainWorkPage = function () {
            var work = _this.selectedWork();
            if (work.format === 'EBook') {
                _this.redirectToPage(app.rootUrl + "work/" + work.id);
            }
            else if (work.format === 'Audiobook') {
                _this.redirectToPage(app.rootUrl + "audiobook/" + work.id);
            }
        };
        this.showAllMarks = function () {
            var popover = _this.$markPopover[0];
            if (popover) {
                ko.cleanNode(popover);
                _this.closeWorkPopover();
                app.f7.popover(popover, ".marksSelector", true, true, true);
                window.history && window.history.pushState("forward", null, "");
                ko.applyBindingsToDescendants(_this, popover);
                _this.backHistoryAfterClose = true;
                _this.$markPopover.one('popover:closed', function () {
                    if (_this.backHistoryAfterClose) {
                        window.history && window.history.back();
                    }
                });
            }
        };
        this.markEnumToCode = function (enumValue) {
            var mark = _.find(_this.options.allMarks, function (x) {
                return x.enumValue === enumValue;
            });
            if (mark)
                return mark.code;
            return "unknown";
        };
        this.activeTab = options.activeTab;
        this.readingCount(options.readingCount);
        this.savedCount(options.savedCount);
        this.finishedCount(options.finishedCount);
        this.dislikedCount(options.dislikedCount);
        this.likedCount(options.likedCount);
        this.purchasedCount(options.purchasedCount);
        this.marksCount(options.marksCount);
        this.allCount(options.allCount);
        this.filtersCount(options.filtersCount);
        $(document).off("submit", "#library-search-form");
        $(document).on("submit", "#library-search-form", function (event) {
            var $form = $(event.currentTarget);
            var elemetsToDelete = [];
            $form.serializeArray().forEach(function (element, index, array) {
                var defaultValue = _this.defaultFilters[element.name];
                if (element.value === "" || defaultValue === element.value) {
                    elemetsToDelete.push(element.name);
                }
            });
            elemetsToDelete.forEach(function (element, index, array) {
                $form.find("[name=\"" + element + "\"]").remove();
            });
        });
        if (!options.isCurrentUser)
            return;
        var self = this;
        $(window).on("popstate", function () {
            _this.backHistoryAfterClose = false;
            _this.closeMarkPopover();
        });
        $(".workcard").on("click", function (e) {
            var target = this;
            var work = JSON.parse($(target).attr("data-work"));
            self.selectedWork(work);
            self.workMarks(work.marks);
            app.f7.popover(self.$workPopover[0], this);
            if (!self.marksLineBarIsTippy) {
                self.createTippy(".marks-line-bar button[data-hint]");
                self.marksLineBarIsTippy = true;
            }
            self.correctPopoverHeight();
        });
        $(".open-popup-filter").on("click", function () {
            _this.app.closePopup();
            _this.app.f7.popup("#filterPopup");
        });
        this.createTippy(this.$markPopover.find("button[data-hint]").toArray());
    }
    ViewModel.prototype.correctPopoverHeight = function () {
        var _this = this;
        setTimeout(function () {
            var windowInner = _this.$workPopover.find("div").first();
            _this.$workPopover.height(windowInner.height());
        }, 100);
    };
    ViewModel.prototype.createTippy = function (els) {
        var self = this;
        setTimeout(function () {
            tippy(els, {
                content: function (c) { return c.getAttribute('data-hint'); },
                trigger: 'click',
                animation: 'scale',
                onShow: function (el) {
                    setTimeout(function () {
                        el.hide();
                    }, self.animationTime / 2);
                },
                zIndex: 14000
            });
        }, 0);
    };
    ViewModel.prototype.hideWork = function (el) {
        el.hide({
            done: function (item) {
                $(item.elem).fadeOut();
                var parentEl = $(item.elem).parents("article");
                if (!parentEl.find(".workcard:visible").length) {
                    parentEl.hide();
                }
                if ($("[data-work-id]:visible").length === 0) {
                    $(".shelf").hide();
                }
            }
        });
    };
    ViewModel.prototype.closeWorkPopover = function () {
        this.$workPopover.hasClass("modal-in") && app.f7.closeModal(this.$workPopover[0]);
    };
    ViewModel.prototype.closeMarkPopover = function () {
        this.$markPopover.hasClass("modal-in") && app.f7.closeModal(this.$markPopover[0]);
    };
    return ViewModel;
}(baseViewModel_1.default));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ViewModel;
//# sourceMappingURL=profileLibrary.js.map